import http from '../../utils/fetch';
import updownfile from '../../utils/updownfile';
export default {
    //分页查询
    selectPage(q){
        return http({
            url: '/api/swyl/v1/dingd/declaration/oversea/selectPage',
            method: 'post',
            params: q
        });
    },
    //获取产品信息
    selectProduct(c){
        return http({
            url: '/api/swyl/v1/dingd/declaration/oversea/selectMaterial?productCode='+ c,
            method: 'post',
            params: c
        })
    },
    selectModel(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistF/selectModel?prodcode=' + v);
    },
    //单条新增
    insertDeclaration(q){
        return http({
            url: '/api/swyl/v1/dingd/declaration/oversea/insertDeclaration',
            method: 'post',
            params: q
        });
    },
    //根据id获取报关单主数据
    selectById(c){
        return http({
            url: '/api/swyl/v1/dingd/declaration/oversea/selectById?id='+ c,
            method: 'post',
            params: c
        })
    },
    //根据id删除数据
    deleteById(c){
        return http({
            url: '/api/swyl/v1/dingd/declaration/oversea/deleteById?id='+ c,
            method: 'post',
            params: c
        })
    },
    // ------------------------------------报关草单--------------------------------------------
    //分页查询
    selectBgPage(q){
        return http({
            url: '/api/swyl/v1/dingd/declaration/draft/selectPage',
            method: 'post',
            params: q
        });
    },
    //获取报关数据
    selectDingdList(c){
        return http({
            url: '/api/swyl/v1/demo/viewOrder/selectDraftData',
            method: 'post',
            params: c
        })
    },
    //获取报关草单数据
    getDeclaration(query){
        return http.post('/api/swyl/v1/dingd/declaration/draft/getDeclaration', query);
    },
    //新增报关数据
    saveDraft(c){
        return http({
            url: '/api/swyl/v1/dingd/declaration/draft/saveDraft',
            method: 'post',
            data: c
        })
    },
    //修改报关数据
    updateDraft(c){
        return http({
            url: '/api/swyl/v1/dingd/declaration/draft/updateDraft',
            method: 'post',
            data: c
        })
    },
    //获取报关草单数据
    selectByDraftId(id){
        return http({
            url: '/api/swyl/v1/dingd/declaration/draft/selectById?id='+ id,
            method: 'post',
            params: id
        })
    },
    //根据id删除数据
    deleteDraftById(c){
        return http({
            url: '/api/swyl/v1/dingd/declaration/draft/deleteById?id='+ c,
            method: 'post',
            params: c
        })
    },
    //获取报关草单数据
    checkDeclaration(query){
        return http.post('/api/swyl/v1/dingd/declaration/oversea/checkDeclaration', query);
    },
    //获取报关草单数据
    checkMaterial(query){
        return http.post('/api/swyl/v1/dingd/declaration/oversea/checkMaterial', query);
    },
}